export const initialState = () => ({
  currentStep: 1,
  isFiltering: false,
  isLoadingScreen: false,
  categorieFilter: {},
  offerFilter: {},
  campaignFilter: {},
  svaFilter: {}
})
